import { AbstractControl } from '@angular/forms';
import { cpf, cnpj } from 'cpf-cnpj-validator';

export class PessoaValidador {

  static cpfOrCnpj(control: AbstractControl) {
    if (cpf.isValid(control.value) || cnpj.isValid(control.value)) {
      return null;
    } else {
      return {cpfOuCnpjInvalido: 'Não é um CPF ou um CNPJ'}
    }
  }
}
